function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarletonH300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1697.0533,
    height: 456.38666,
    viewBox: "0 0 1697.0533 456.38666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g8",
    groupmode: "layer",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,456.38667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1415.78,2802.99 -256.8,-0.74 -36.16,229.45 c -34.04,33.82 -76.94,60.52 -128.644,80.1 -51.727,19.55 -112.715,29.25 -182.918,29.05 -149.906,-0.44 -265.129,-55.22 -345.66,-164.34 -80.555,-109.12 -120.559,-251.24 -120.051,-426.37 l 0.18,-60.36 c 0.527,-175.14 41.175,-317.43 121.972,-426.82 80.797,-109.48 194.563,-163.94 341.317,-163.5 67.836,0.17 129.933,10.23 186.293,30.12 56.331,19.85 99.861,46.82 130.521,80.86 l 34.83,229.69 256.8,0.75 1.01,-340.81 C 1349.26,1819.38 1260.9,1755.05 1153.36,1706.98 1045.8,1658.96 925.367,1634.7 792.035,1634.29 560.887,1633.61 371.297,1713.13 223.289,1872.86 75.3047,2032.59 0.914063,2237.87 0.1875,2488.77 l -0.18359375,57.97 C -0.722656,2796.83 72.0469,3002.57 218.297,3163.94 c 146.269,161.39 335.758,242.4 568.504,243.09 133.308,0.41 253.709,-23.49 361.139,-71.72 107.42,-48.19 196.38,-112.02 266.83,-191.51 l 1.01,-340.81",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2061.09,1886.71 c 50.63,0.15 96.66,11.2 138.02,33.18 41.37,22.03 73.52,49.55 96.44,82.62 l -0.57,189.93 -171.5,-0.51 c -71.35,-0.24 -125.4,-17.11 -162.15,-50.53 -36.73,-33.5 -55.03,-73.69 -54.89,-120.49 0.13,-42.23 13.84,-75.14 41.17,-98.85 27.29,-23.71 65.13,-35.51 113.48,-35.35 z m 291.87,-223.59 c -9.28,20.68 -17.4,41.96 -24.36,63.82 -6.98,21.86 -12.42,43.84 -16.32,66.14 -39.77,-46.17 -88.2,-83.56 -145.27,-112.11 -57.08,-28.51 -122.45,-42.94 -196.12,-43.18 -122,-0.35 -218.99,32.56 -290.93,98.7 -71.96,66.18 -108.08,156.43 -108.44,270.78 -0.33,116.63 46.21,206.92 139.64,270.89 93.43,63.98 230.69,96.23 411.79,96.78 l 171.5,0.51 -0.37,122.01 c -0.18,59.86 -17.58,106.22 -52.2,139.11 -34.63,32.89 -85.71,49.25 -153.22,49.06 -38.38,-0.12 -72.51,-4.67 -102.42,-13.57 -29.9,-8.91 -54.05,-19.54 -72.41,-31.87 l -21.49,-133.58 -253.22,-0.75 0.33,276.26 c 61.27,41.61 131.58,76.74 210.91,105.37 79.33,28.6 165.81,43.08 259.43,43.35 154.25,0.45 279.61,-36.98 376.14,-112.25 96.52,-75.32 145.01,-182.81 145.42,-322.46 l 1.51,-514.5 c 0.06,-19.19 0.3,-37.24 0.75,-54.11 0.41,-16.87 1.81,-32.99 4.17,-48.32 l 102.47,-13.53 0.61,-201.41 -387.9,-1.14",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2858,1866.1 161.04,35.04 -2.28,772.31 -178.5,34.02 -0.61,202.57 491.49,1.45 15.49,-181.81 c 28.96,64.53 66.44,114.91 112.37,151.12 45.93,36.2 99.21,54.38 159.82,54.56 17.66,0.06 36.26,-1.23 55.84,-3.87 19.58,-2.63 35.88,-5.84 48.96,-9.61 l -34.78,-306.31 -138.14,3.07 c -49.12,-0.16 -89.76,-9.89 -121.92,-29.16 -32.19,-19.29 -56.67,-46.58 -73.44,-81.95 l 1.79,-605.41 161.26,-34.09 0.59,-201.41 -658.38,-1.93 -0.6,201.41",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3765.01,3213.4 -0.61,202.59 515.66,1.51 4.62,-1512.74 162.4,-34.1 0.59,-201.41 -660.68,-1.92 -0.61,201.41 162.19,35.03 -3.91,1275.64 -179.65,33.99",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5112.52,2680.71 c -62.15,-0.18 -111.21,-24.1 -147.13,-71.8 -35.92,-47.68 -58,-110.27 -66.2,-187.81 l 3.46,-5.72 412.07,1.22 -0.08,29.92 c -0.22,71.34 -17.07,128.27 -50.57,170.76 -33.5,42.49 -84.03,63.65 -151.55,63.43 z m 0.02,-1033.56 c -179.57,-0.51 -323.26,56.63 -431,171.41 -107.78,114.78 -161.93,260.83 -162.44,438.05 l -0.14,46.05 c -0.55,184.94 49.82,337.43 151.16,457.42 101.31,119.99 237.52,179.88 408.66,179.61 168.04,0.51 298.63,-49.76 391.79,-150.78 93.13,-101 139.99,-237.85 140.5,-410.51 l 0.53,-183.01 -743.55,-2.2 -2.3,-6.88 c 6.39,-82.11 34.01,-149.55 82.91,-202.36 48.88,-52.81 115.14,-79.08 198.77,-78.84 74.44,0.24 136.2,7.86 185.25,23 49.08,15.1 102.71,38.85 160.95,71.26 l 91.54,-206.92 c -51.29,-40.82 -117.75,-75.15 -199.4,-103.03 -81.63,-27.84 -172.73,-41.95 -273.23,-42.27",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6164.55,3255.04 0.9,-334.86 218.7,0.65 0.71,-235.95 -218.7,-0.65 1.87,-634.26 c 0.14,-48.32 10.22,-82.81 30.24,-103.45 19.99,-20.69 46.89,-30.95 80.65,-30.83 23.02,0.04 43.18,1.06 60.42,3.03 17.28,1.96 36.63,5.3 58.1,9.98 l 29.49,-242.81 c -37.55,-11.6 -74.75,-20.37 -111.56,-26.23 -36.82,-5.86 -76.72,-8.85 -119.68,-9.01 -115.88,-0.31 -205.18,31.26 -267.9,94.77 -62.74,63.51 -94.3,164.33 -94.71,302.43 l -1.87,635.38 -116.89,-0.53 -0.71,235.95 116.89,0.53 -0.9,334.85 334.95,1.01",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6830.82,2286.85 c 0.33,-113.56 20.55,-204.67 60.65,-273.21 40.11,-68.58 104.66,-102.71 193.69,-102.44 86.7,0.28 150.11,34.96 190.18,104.17 40.09,69.17 59.97,160.16 59.63,272.98 l -0.07,24.18 c -0.34,110.5 -20.94,200.57 -61.82,270.31 -40.87,69.7 -105.05,104.42 -192.52,104.16 -87.48,-0.25 -151.08,-35.37 -190.76,-105.3 -39.71,-69.98 -59.39,-160.17 -59.06,-270.66 z m -336.17,23.18 c -0.55,185.68 50.98,337.96 154.6,456.83 103.63,118.86 247.14,178.57 430.54,179.12 184.17,0.53 328.4,-58.14 432.75,-175.97 104.32,-117.89 156.76,-270.07 157.31,-456.5 l 0.08,-24.18 c 0.55,-187.25 -51.01,-339.9 -154.62,-458.03 -103.64,-118.05 -246.77,-177.38 -429.38,-177.93 -184.94,-0.55 -329.57,57.92 -433.89,175.37 -104.34,117.54 -156.78,269.88 -157.33,457.11 l -0.06,24.18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7755.81,1881.08 161.04,35.04 -2.28,772.32 -178.5,34.01 -0.61,202.57 491.49,1.46 15.48,-178.37 c 41.24,63.8 92.13,113.46 152.67,148.93 60.49,35.47 128.34,53.32 203.57,53.56 125.83,0.37 224.16,-38.87 295,-117.69 70.82,-78.82 106.5,-202.65 106.99,-371.48 l 1.62,-542.09 161.24,-34.09 0.61,-201.41 -642.28,-1.93 -0.61,201.41 143.79,35 -1.6,540.96 c -0.25,83.64 -17.32,142.88 -51.17,177.7 -33.88,34.82 -84.96,52.13 -153.26,51.93 -44.5,-0.14 -84.39,-9.28 -119.6,-27.41 -35.28,-18.15 -64.73,-43.75 -88.42,-76.82 l 1.96,-667.58 135.94,-34.17 0.59,-201.41 -633.05,-1.85 -0.61,201.41",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3128.48,1194.83 0.33,-112.61 -99.77,-19.53 1.44,-486.35 c 0.18,-61.461 16.84,-107.371 49.99,-137.789 33.16,-30.391 78.54,-45.473 136.13,-45.289 58.45,0.148 104.26,15.41 137.45,45.828 33.19,30.351 49.7,76.512 49.52,138.379 l -1.44,486.351 -99.26,18.91 -0.32,112.61 385.87,1.13 0.33,-112.61 -99.77,-19.5 1.44,-486.348 c 0.31,-104.524 -33.91,-185.301 -102.64,-242.203 -68.73,-56.95 -158.98,-85.59 -270.75,-85.911 -111.35,-0.367 -201.34,27.762 -269.99,84.301 -68.63,56.512 -103.11,137.063 -103.42,241.59 l -1.44,486.351 -99.25,18.91 -0.33,112.62 99.19,0.29 186.86,0.54 99.83,0.33",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3740.12,376.871 89.53,19.449 -1.27,429.371 -99.24,18.911 -0.33,112.648 273.25,0.801 8.61,-99.172 c 22.93,35.492 51.21,63.07 84.87,82.812 33.64,19.75 71.36,29.661 113.18,29.77 69.96,0.219 124.64,-21.609 164.02,-65.402 39.37,-43.829 59.2,-112.688 59.48,-206.539 l 0.89,-301.411 89.65,-18.91 0.32,-112 -357.07,-1.058 -0.33,112 79.94,19.418 -0.9,300.761 c -0.13,46.489 -9.62,79.418 -28.45,98.801 -18.83,19.309 -47.23,28.969 -85.19,28.859 -24.75,-0.07 -46.93,-5.171 -66.52,-15.269 -19.59,-10.051 -35.98,-24.301 -49.14,-42.699 l 1.1,-371.141 75.56,-18.949 0.33,-111.992 -351.96,-1.059 -0.33,112",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4851.4,1126.3 -186.86,-0.55 -0.42,140.16 186.86,0.55 z m -274.89,-746.96 90.18,19.461 -1.28,429.371 -99.88,18.91 -0.33,112.648 286.69,0.84 1.66,-561.23 89.65,-18.899 0.32,-112 -366.68,-1.089 -0.33,111.988",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5268.28,849.262 -65.24,-12.352 92.43,-309.469 12.35,-65.211 h 3.85 l 13.24,65.29 89.31,309.351 -66.58,12.609 -0.33,112.649 314.2,0.949 0.33,-112.648 -60.13,-9.77 -202.45,-570.801 -178.54,-0.507 -206.47,569.558 -60.18,9.399 -0.32,112.66 314.21,0.941 0.32,-112.648",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5999.25,832.941 c -34.56,-0.113 -61.83,-13.41 -81.79,-39.902 -19.98,-26.519 -32.25,-61.309 -36.81,-104.41 l 1.93,-3.207 229.09,0.66 -0.04,16.648 c -0.12,39.668 -9.5,71.329 -28.12,94.942 -18.63,23.648 -46.73,35.379 -84.26,35.269 z m 18.34,-574.589 c -99.82,-0.293 -179.71,31.437 -239.62,95.269 -59.92,63.801 -90.03,145.008 -90.32,243.559 l -0.07,25.57 c -0.3,102.82 27.71,187.602 84.04,254.352 56.33,66.668 132.06,100.007 227.2,99.82 93.43,0.297 166.05,-27.652 217.84,-83.793 51.78,-56.18 77.82,-132.258 78.1,-228.258 l 0.3,-101.762 -413.4,-1.199 -1.27,-3.82 c 3.55,-45.66 18.9,-83.18 46.09,-112.512 27.17,-29.367 64.02,-43.976 110.52,-43.828 41.37,0.148 75.71,4.371 102.99,12.789 27.27,8.383 57.1,21.602 89.47,39.602 l 50.91,-115.02 c -28.53,-22.699 -65.48,-41.789 -110.87,-57.312 -45.38,-15.481 -96.03,-23.321 -151.91,-23.457",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6369.29,384.922 89.53,19.449 -1.27,429.367 -99.25,18.91 -0.33,112.653 273.25,0.801 8.61,-101.063 c 16.11,35.852 36.94,63.859 62.48,84.012 25.54,20.109 55.15,30.211 88.86,30.32 9.81,0.027 20.16,-0.699 31.04,-2.152 10.88,-1.5 19.95,-3.25 27.21,-5.36 l -19.33,-170.289 -76.8,1.711 c -27.3,-0.07 -49.9,-5.5 -67.78,-16.211 -17.89,-10.711 -31.51,-25.898 -40.83,-45.539 l 1,-336.609 89.64,-18.953 0.33,-111.989 -366.04,-1.058 -0.32,112",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7442.19,730.52 -125.43,-0.36 -20.1,86.309 c -12.83,10.203 -28.95,18.691 -48.39,25.472 -19.44,6.77 -40.89,10.129 -64.34,10.047 -32.85,-0.109 -58.85,-7.539 -78,-22.289 -19.16,-14.801 -28.71,-33.301 -28.64,-55.488 0.06,-20.91 9.29,-38.262 27.67,-52.031 18.38,-13.84 55.11,-26.008 110.17,-36.469 85.81,-16.832 149.45,-41.711 190.93,-74.652 41.47,-32.969 62.3,-78.438 62.48,-136.438 0.18,-62.301 -26.44,-113.242 -79.86,-152.84 -53.43,-39.64 -123.87,-59.57 -211.32,-59.859 -53.34,-0.152 -102.32,7.5 -146.94,22.949 -44.63,15.449 -84.26,37.598 -118.9,66.527 l -2.38,155.5 130.54,0.364 25.87,-90.172 c 11.11,-9.328 26.28,-16.211 45.49,-20.66 19.22,-4.371 39.27,-6.59 60.17,-6.52 37.98,0.11 66.86,6.988 86.66,20.731 19.79,13.73 29.66,32.281 29.58,55.738 -0.05,20.48 -10.13,38.18 -30.23,53.051 -20.1,14.859 -57.03,27.98 -110.82,39.351 -81.54,16.391 -143.14,40.84 -184.84,73.367 -41.69,32.543 -62.62,76.922 -62.79,133.243 -0.17,58 23.58,108.097 71.23,150.289 47.66,42.148 115.65,63.359 203.96,63.609 53.75,0.18 104.64,-6.918 152.69,-21.269 48.04,-14.399 85.73,-32.829 113.11,-55.348 l 2.43,-172.152",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7821.76,1135.45 -186.87,-0.55 -0.42,140.16 186.87,0.55 z m -274.89,-747.001 90.17,19.492 -1.27,429.368 -99.88,18.91 -0.33,112.652 286.69,0.84 1.66,-561.223 89.64,-18.949 0.33,-111.988 -366.68,-1.09 -0.33,111.988",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8219.88,1140.55 0.51,-169.562 121.59,0.364 0.38,-131.204 -121.59,-0.359 1.05,-352.598 c 0.07,-26.89 5.68,-46.089 16.8,-57.57 11.13,-11.48 26.07,-17.199 44.85,-17.121 12.8,0.031 24,0.621 33.59,1.672 9.6,1.098 20.37,2.949 32.31,5.539 l 16.4,-134.981 c -20.89,-6.449 -41.57,-11.3 -62.04,-14.582 -20.47,-3.238 -42.65,-4.918 -66.54,-4.988 -64.42,-0.18 -114.07,17.379 -148.94,52.68 -34.88,35.308 -52.42,91.379 -52.65,168.14 l -1.05,353.258 -64.44,-0.328 -0.38,131.199 64.44,0.332 -0.51,169.559 186.22,0.55",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9150.54,861.07 -64.6,-9.769 -252.71,-674.602 C 8813.32,126.75 8786.68,84.8203 8753.3,51.0391 8719.9,17.2305 8669.5,0.21875 8602.1,0 c -15.78,-0.0390625 -30.61,1.19922 -44.48,3.75 -13.89,2.51172 -30.21,6.08984 -48.99,10.7109 l 21.35,136.4101 c 5.98,-0.883 12.17,-1.68 18.57,-2.551 6.4,-0.8 11.94,-1.238 16.63,-1.238 31.15,0.109 55.02,7.758 71.62,22.949 16.59,15.199 29.33,34.141 38.23,56.731 l 20.96,52.539 -221.19,569.519 -64.66,10.059 -0.33,112.652 339.16,1.02 0.33,-112.653 -77.39,-13.039 95.53,-276.168 9.74,-49.882 3.85,-0.618 108.46,327.321 -78.12,12.566 -0.32,112.652 339.16,0.989 0.33,-112.649",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12725.3,2388.14 -548,-590.96 236.9,1033.71 -315.5,-167.01 -236.5,643.47 -236.6,-643.47 -315.5,167.01 236.9,-1033.71 -559.7,603.56 -36.3,-263.55 -458.9,133.84 211.8,-500.57 -194.4,-53.03 655.8,-489.71 c 746.1,287.79 1214.2,204.19 1488.4,93 -40.3,-157.59 -100,-304.12 -178.9,-439.4 -22.1,12.11 -45.2,23.84 -69.8,34.981 -95.3,43.211 -209.8,78.258 -347.6,98.699 -53,7.86 -109.6,13.46 -169.6,16.64 -16.8,0.89 -33.8,1.58 -51.1,2.07 -33,0.93 -67,1.1 -102.1,0.5 -155,-2.67 -330.6,-20.65 -530.2,-58.929 -7.5,-1.453 -14.9,-2.66 -22.3,-4.011 -36.3,-6.59 -71.6,-12.11 -106,-16.61 -501.2,-65.539 -810.5,82.84 -995.9,252.08 -19.3,55.47 -35.9,111.69 -49.5,168.67 185.9,-194.02 513.6,-364.01 1056.7,-176.26 l -733.7,547.85 255.2,69.59 -237.9,562.16 522.1,-152.28 45.4,329.13 482.7,-520.49 -212.8,928.27 379.4,-200.85 231.3,629.04 c 30.4,-4 60.7,-8.39 91,-13.11 l 226.4,-615.93 379.4,200.85 -212.7,-928.27 422.5,455.68 -0.4,-102.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11085.5,838.109 c -516.9,-41.308 -808.2,102.832 -972.6,281.341 26.7,-65.51 57.2,-129.93 91.7,-193.18 1.8,-3.321 3.7,-6.54 5.6,-9.848 153.9,-112.981 412.4,-220.211 846.9,-255.371 456.1,-36.91 756.1,-159.723 953.4,-300.403 119.3,92.082 223.9,193.243 313.6,303.293 -223.4,127.321 -600.9,225.137 -1238.6,174.168",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10210.2,916.422 c 246.6,-446.012 643,-698.703 1101.1,-897.9806 27.2,-11.83202 56.8,-12.45312 83.9,0 134.3,62.25 283.5,124.2696 409.4,200.9686 72.9,44.449 141.5,91.551 205.9,141.238 -197.3,140.68 -497.3,263.493 -953.4,300.403 -434.5,35.16 -693,142.39 -846.9,255.371",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11204.4,975.281 C 10627,864.52 10281,1023.3 10080.2,1206.56 c 10.2,-29.24 21,-58.3 32.7,-87.11 164.4,-178.509 455.7,-322.649 972.6,-281.341 637.7,50.969 1015.2,-46.847 1238.6,-174.168 56.2,68.989 106.5,141.5 150.8,217.547 -244.4,134.212 -638.5,215.022 -1270.5,93.793",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12515.9,2963.38 -212.7,-928.27 422.5,455.68 c 0.6,207.04 0.2,414.1 2.2,621.07 0.5,37.66 -8.5,58.72 -48.1,72.25 -251.9,86.4 -508.1,153.52 -769.7,194.35 l 226.4,-615.93 379.4,200.85",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11087.4,1199.15 -733.7,547.85 255.2,69.59 -237.9,562.16 522.1,-152.28 45.4,329.13 482.7,-520.49 -212.8,928.27 379.4,-200.85 231.3,629.04 c -63.5,8.37 -127.4,15.23 -191.5,20.32 -543.4,43.03 -1069.8,-42.27 -1583,-220.72 -49.62,-17.37 -66.68,-39.5 -66.07,-92.22 2.92,-232.85 2.77,-698.87 2.77,-698.87 0,-209.95 -2.15,-419.9 0.46,-629.85 1.73,-135.31 18.34,-267.01 48.94,-394.97 185.9,-194.05 513.6,-363.84 1056.7,-176.11",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12653.8,1320.67 c 34.8,135.8 55.2,279.81 60.6,432.19 7.5,211.63 10,423.44 10.9,635.28 l -548,-590.96 236.9,1033.71 -315.5,-167.01 -236.5,643.47 -236.6,-643.47 -315.5,167.01 236.9,-1033.71 -559.7,603.56 -36.3,-263.55 -458.9,133.84 211.8,-500.57 -194.4,-53.03 655.8,-489.71 c 746.2,287.83 1214.3,204.16 1488.5,92.95",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarletonH300);
export default __webpack_public_path__ + "static/media/carleton-H-300.952a894a85a7e79e9aa7a1bf3b161e22.svg";
export { ForwardRef as ReactComponent };